module.exports = __webpack_public_path__ + "img/section5_larry_with_money.fb818350.svg";